import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewContainerRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CorporateUser, EntityTypes, JobOrder, JobSubmission } from "@bullhorn/bullhorn-types";
import { EntityPickerResult, EntityPickerResults, FormUtils, NovoAsideService, NovoModalRef, NovoModalService, NovoToastService, PickerControl, PickerResults, QuickNoteControl, SelectControl, TextAreaControl, TextBoxControl } from "novo-elements";
import { UserSettings } from "src/app/interfaces/bullhorn";
import { AppBridgeService } from "src/app/services/appBridge.service";
import { AppBridgeTargetService } from "src/app/services/appBridgeTarget.service";
import { HttpService } from "src/app/services/http.service";
import { HttpTargetService } from "src/app/services/httpTarget.service";
import { MetaService } from "src/app/services/meta.service";

@Component({
  selector: 'demo-page-2',
  templateUrl: './add-target.component.html',
  styleUrls: ['./add-target.component.scss']
})
export class DemoPage2Component {
  public loading = true;
  public connected = true;
  public textControl: any;
  public candidatePickerControl: any;
  public ownerPickerControl: any;
  public jobOrderPickerControl: any;
  public commentsControl: QuickNoteControl;
  public textForm: any;
  public fieldConfig;
  public dynamic: any;
  public jobOrder: JobOrder | any;
  public submission: JobSubmission | any;
  public fromUser: CorporateUser | any;
  public dynamicForm: any;
  constructor(private appBridgeService: AppBridgeTargetService, private httpService: HttpTargetService, private formUtils: FormUtils, private meta: MetaService, private route: ActivatedRoute, private toastService: NovoToastService, private viewContainerRef: ViewContainerRef) {
    this.toastService.parentViewContainer = viewContainerRef;
    document.documentElement.className = 'custom-menu-item';
    this.formUtils = formUtils;
  }

  ngOnInit() {
    this.onRegistered(true);
  }


  private async onRegistered(isRegistered, ...args) {
    if (isRegistered) {
      this.loading = false;

        this.textControl = new TextBoxControl({ key: 'summary', label: 'Phone', readOnly: false, value: ``});
        this.jobOrderPickerControl = new SelectControl({
          key: 'jobOrder',
          multiple: false,
          label: 'Status',
          required: true,
          options: [
            'Active',
            'Closed',
            'Open',
            'Placed',
            'Canceled',
          ],
          interactions: [{invokeOnInit: true, event: 'change', script: (API) => {
            const currentStatus = API.getActiveValue();
              
              if(currentStatus === 'Active') {
                  API.displayToast({
                    title: 'Candidate Updated to Active',
                    message: 'Please ensure you have introduced yourself to the candidate before saving this change',
                  });
                
                  API.setRequired('phone', true);
              } else {
                API.setRequired('phone', false);
              }
          } 
        }],
        });
        this.candidatePickerControl = new PickerControl({
          key: 'candidates',
          multiple: true,
          label: 'Candidate',
          required: true,
          readOnly: true,
          config: {
            format: '$label',
            previewTemplate: EntityPickerResult,
            resultsTemplate: EntityPickerResults,
            type: 'Candidate',
            options: [{
              searchEntity:'Candidate', 
              value: 'Apple',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'Candidate', 
              value: 'Banana',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'Candidate', 
              value: 'Grapes',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'Candidate', 
              value: 'Orange',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'Candidate',
              value: 'Pear',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }],
          },
        });
        this.ownerPickerControl = new PickerControl({
          key: 'owner',
          multiple: true,
          label: 'Candidate Recruiter',
          required: true,
          readOnly: true,
          config: {
            format: '$label',
            previewTemplate: EntityPickerResult,
            resultsTemplate: EntityPickerResults,
            type: 'User',
            options: [{
              searchEntity:'CorporateUser', 
              value: 'Apple',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'CorporateUser', 
              value: 'Banana',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'CorporateUser', 
              value: 'Grapes',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'CorporateUser', 
              value: 'Orange',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'CorporateUser',
              value: 'Pear',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }],
          },
        });
        this.commentsControl = new QuickNoteControl({ 
          key: 'comments', 
          label: 'Comments',
          config: {
            triggers: {
            },
            options: {
            },
            renderer: {
            },
          }
        });
        this.textForm = this.formUtils.toFormGroup([this.textControl, this.candidatePickerControl, this.ownerPickerControl, this.commentsControl, this.jobOrderPickerControl]);
  
      //this.dynamicForm = this.formUtils.toFormGroupFromFieldset(this.dynamic);
    } else {
      this.connected = false;
      this.loading = false;
    }
  } 

  public searchData: any[] = [
    {
      data: {
        title: 'Central Bank',
        name: 'Central Bank',
        email: 'new-bank-inquiries@centralbank.com',
        phone: '(651) 555-1234',
        address: { city: 'Washington', state: 'DC' },
        searchEntity: 'ClientCorporation',
        type: 'company',
      },
    },
    {
      data: {
        title: 'Federal Bank',
        name: 'Federal Bank',
        email: 'info@federalbank.com',
        phone: '(545) 555-1212',
        address: { city: 'Arlington', state: 'VA' },
        searchEntity: 'ClientCorporation',
        type: 'company',
      },
    },
    {
      data: {
        title: 'Aaron Burr',
        firstName: 'Aaron',
        lastName: 'Burr',
        name: 'Aaron Burr',
        companyName: 'Central Bank',
        email: 'aburr@centralbank.com',
        phone: '(333) 555-3434',
        address: { city: 'Washington', state: 'DC' },
        status: 'Hold',
        searchEntity: 'ClientContact',
        type: 'person',
      },
    },
    {
      data: {
        title: 'Alexander Hamilton',
        firstName: 'Alexander',
        lastName: 'Hamilton',
        name: 'Alexander Hamilton',
        companyName: 'Federal Bank',
        email: 'ahamilton@federalbank.com',
        phone: '(333) 555-2222',
        address: { city: 'Arlington', state: 'VA' },
        status: 'Active',
        searchEntity: 'ClientContact',
        type: 'person',
      },
    },
    {
      data: {
        title: 'Ben Franklin',
        firstName: 'Ben',
        lastName: 'Franklin',
        name: 'Ben Franklin',
        email: 'bfranklin@gmail.com',
        phone: '(654) 525-2222',
        address: { city: 'Boston', state: 'MA' },
        status: 'Interviewing',
        searchEntity: 'Candidate',
        type: 'candidate',
      },
    },
    {
      data: {
        title: 'Thomas Jefferson',
        firstName: 'Thomas',
        lastName: 'Jefferson',
        name: 'Thomas Jefferson',
        email: 'tjefferson@usa.com',
        phone: '(123) 542-1234',
        address: { city: 'Arlington', state: 'VA' },
        status: 'New Lead',
        searchEntity: 'Candidate',
        type: 'candidate',
      },
    },
  ];

}